import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import { Credentials } from 'safe'
import { AuthService } from '../services/AuthService'
import { isNevulaDisabled } from './utils'

const server = process.env.REACT_APP_ADMIN_SERVER
let authInstance = new AuthService()

const onRequest = async (
  config: InternalAxiosRequestConfig
): Promise<InternalAxiosRequestConfig> => {
  const credentials: Credentials | null = JSON.parse(
    localStorage.getItem('credentials') || 'null'
  )

  // let variable = new Date(2022, 10, 31, 0, 25, 0)

  // console.log("hace peticion", new Date())
  // console.log("hace peticion 2", new Date(2023, 10, 29, 3, 24, 0) )
  // console.log("hace peticion 3", new Date(2023, 10, 29, 3, 24, 0) )

  if (isNevulaDisabled()) {
    console.log('llgenaod...')
    localStorage.removeItem('credentials')
    /** Este valor se usar para saber si mostrar el toast y deshabilitar nevula cuando son los primeros de cada mes entre 12 y 12:20 
     * Este valor se usa en /ingresar para mostrar toast
    */
    localStorage.setItem('nevulaAdvice', JSON.stringify(true))
    return config
  }

  // console.log('out..')
  // console.log("port", window.location.port)
  if (credentials) {
    config.headers = config.headers ?? {};

    config.headers.Authorization = credentials.access_token
    // console.log('in..')
    // const { access_token, timeToLeave } = credentials
    // const now = new Date().getTime() / 1000
    // const diff = 2 * 3600
    // if (now > timeToLeave) {
    //   //log-out
    //   localStorage.removeItem('credentials')
    //   return config
    // }
    // if (now > timeToLeave - diff) {
    //   //logica de refresh token
    //   // config.headers.Authorization = credentials.refresh_token
    //   // let response = await axios.post(`${server}/auth/refresh-token`)
    //   fetch(`${server}/auth/refresh-token`, {
    //     headers: new Headers({
    //       Authorization: `${credentials.refresh_token}`,
    //     }),
    //     method: 'POST',
    //   })
    //     .then((res) => res.json())
    //     .then((response) => {
    //       console.log('response', response)
    //       let bodyToken = {
    //         access_token: response.access_token,
    //         refresh_token: response.refresh_token,
    //       }
    //       localStorage.removeItem('credentials')
    //       localStorage.setItem('credentials', JSON.stringify(bodyToken))
    //     })
    // }
    // console.log('parsed', timeToLeave)
    // config.headers = {
    //   Authorization: `${credentials.access_token}`,
    // }
  }
  return config
  // let now = new Date().getTime()
  // console.log("now", nows)
}

const onResponse = (response: AxiosResponse): AxiosResponse => {
  return response
}

const onErrorResponse = async (error) => {
  const originalRequest = error.config
  // console.log("VER EL ERROR", error)
  // console.log("VER EL ERROR 2", error?.response?.status)
  // console.log("VER EL ERROR 3", error?.message)
  // console.log("VER EL ERROR 4", error?.status)
  // console.log("error", error.response)
  // const credentials = JSON.parse(localStorage.getItem('credentials') || '{}')
  // console.log('ERROR GENERAL', error?.response?.status)
  if ( (error?.response?.status === 401 || error?.response?.status === undefined) && !originalRequest._retry) {
    let credential = localStorage.getItem('credentials')

    originalRequest._retry = true;
    let newToken = ""

    if (!credential) {
      return window.location.href = '/ingresar'
    } else {

      try {
        newToken = await authInstance.refreshToken()
      } catch (err : any) {
        console.log("new token", err)
        if (err?.code === "UserNotFoundException" && credential) {
          localStorage.removeItem('credentials')
          return window.location.href = '/ingresar'
        }
      }
      // console.log("response", response)
      axios.defaults.headers.common['Authorization'] = newToken
      const credentials = {
        access_token: newToken
      } 
      localStorage.setItem('credentials', JSON.stringify(credentials))
      
    }

    // let access_token = localStorage.getItem('credentials')
    // if (access_token) {
    //   access_token = JSON.parse(access_token).access_token
    // }
    // console.log("acces", access_token)
    // axios.defaults.headers.common['Authorization'] = access_token
    // originalRequest._retry = true;
    // localStorage.removeItem('credentials')
    // history.push('/ingresar')
    // console.log("ver1", window.location.hostname)
    // console.log("ver2", window.location.pathname)
    // window.location.href = `${window.location.hostname}/ingresar`
    // window.location.href = `${window.location.protocol}//${window.location.hostname}${window.location.hostname === 'localhost' ? `:${window.location.port}` : ''}/ingresar`;
    // throw new axios.Cancel('Token is expired')
    // return axios(originalRequest)
    // throw new Error('Token vencido')
    // return axios.request(error.config);
    return axios(originalRequest)
  } 
  if (error?.response?.status === 403) {
    console.log('entrando...')
    localStorage.removeItem('credentials')
    // throw new axios.Cancel('Token is expired')
    return window.location.href = '/ingresar'
  }
  // if (error.response) {
  //   throw error
  //   // return Promise.reject('Network Error')
  // } else if (error?.response?.status === 401) {
  //   console.log("llega...")
  //   localStorage.removeItem("credentials")
  //   throw new Error('Refresh Token is invalid')
  // }

  // if (!error.response) {
  //   console.log("if 1")
  //   return Promise.reject('Network Error')
  // } else if (error.response.status === 401 && !originalRequest._retry) {
  //   console.log("if 2")
  //   originalRequest._retry = true
  //   const body = {
  //     tenantCode: credentials.tenantCode,
  //     token: credentials.RefreshToken,
  //   }
  //   try {
  //     let res = await axios.post(`${server}/refresh`, body)
  //     if (res.status !== 200) {
  //       console.log("if 3")
  //       localStorage.removeItem('credentials')
  //       throw new Error('Refresh Token is invalid')
  //     } else {
  //       console.log("if 4")
  //       credentials.IdToken = res.data.IdToken
  //       localStorage.setItem('credentials', JSON.stringify(credentials))
  //       return axios(originalRequest)
  //     }
  //   } catch (e: any) {
  //     throw error
  //   }
  // } else {
  //   console.log("if 5")
  //   throw error
  // }
    return Promise.reject(error)
}

export function setupInterceptors(axiosInstance: AxiosInstance): AxiosInstance {
  console.log("Axios instance...", axiosInstance)
  axiosInstance.interceptors.request.use(onRequest)
  axiosInstance.interceptors.response.use(onResponse, onErrorResponse)
  return axiosInstance
}
